import script from "./sidebar-section.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar-section.vue?vue&type=script&setup=true&lang=js"

import "./sidebar-section.vue?vue&type=style&index=0&id=51a391b7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51a391b7"]])

export default __exports__